import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import CustomButton from "../other/common/CustomButton";
import deepakSharmaImg from "../../assets/images/webp/other/deepak-sharma.webp";

const MeetAuthor = () => {
  return (
    <>
      <div className="bg-[#EAF3EE]">
        <div className="container mx-auto 2xl:max-w-[1300px]">
          <div className="flex items-center max-lg:flex-wrap gap-[74px] max-xl:gap-12 max-lg:gap-9 max-md:gap-6">
            <img
              src={deepakSharmaImg}
              alt="author"
              width={629}
              height={643}
              className="w-full max-w-[629px] max-xl:max-w-[500px] max-md:max-w-[400px] pointer-events-none max-lg:mx-auto"
            />
            <div className="max-lg:px-4 max-xl:py-10 max-lg:pt-0 max-lg:pb-10">
              <BlueHeading lineClassOne="!hidden" text="Meet the Author" />
              <h2 className="font-normal ff-jakarta text-[50px] max-xl:text-5xl max-lg:text-4xl max-md:text-3xl leading-[120%] max-w-[550px]">
                <span className="font-bold">Deepak Sharma:</span>The Mind
                Architect
              </h2>
              <p className="text-[#686868] text-base font-normal leading-[150%] pt-2 max-w-[589px] max-lg:max-w-none">
                Deepak Sharma is a seeker, experimenter, and mind architect. He
                has spent years exploring consciousness, manifestation, mental
                programming, and energy dynamics. From ancient Indian practices
                to modern psychology, Deepak blends deep wisdom with real-world
                application.
              </p>
              <div className="pt-6">
                <h3 className="font-bold ff-jakarta text-[32px] max-xl:text-3xl max-lg:text-2xl max-md:text-xl leading-[120%]">
                  His Mission:-
                </h3>
                <p className="text-[#001A3D] font-normal text-sm leading-[150%] max-lg:max-w-none pt-4 max-w-[466px]">
                  To awaken people to the king within their mind – and help them
                  set their inner thermostat to limitless potential.
                </p>
                <CustomButton
                  text="Invite for Seminar"
                  myClass="mt-10 max-md:mt-6"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetAuthor;
